import { createFileRoute } from "@tanstack/react-router";
import { AppLayout } from "@/components/app-layout";
import { MemoryHealthPanel } from "@/components/admin/memory-health-panel";

export const Route = createFileRoute("/admin/memory")({
  component: AdminMemoryPage,
  head: () => ({
    meta: [
      { title: "Memory Health — AskBell Admin" },
      { name: "description", content: "Review and clean up cross-chat memory profiles." },
      { property: "og:title", content: "Memory Health — AskBell Admin" },
      { property: "og:description", content: "Review and clean up cross-chat memory profiles." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
});

function AdminMemoryPage() {
  return (
    <AppLayout>
      <div className="flex-1 min-h-0 overflow-y-auto">
        <div className="mx-auto w-full max-w-5xl p-6">
          <h1 className="text-ui-2xl font-bold">Memory health</h1>
          <p className="mt-1 text-ui-base text-muted-foreground">
            Cross-chat memory profile quality, capped users, and cleanup controls.
          </p>

          <div className="mt-6">
            <MemoryHealthPanel />
          </div>
        </div>
      </div>
    </AppLayout>
  );
}
